/**
 * Cabecera reutilizable de la app. Acepta un título (texto o ReactNode)
 * y contenido en la zona derecha (ej: botón de usuario).
 */
import styles from './Header.module.css';

interface HeaderProps {
    title?: string;
    titleContent?: React.ReactNode;
    /** Contenido opcional a la izquierda (p. ej. acción extra). */
    leftContent?: React.ReactNode;
    rightContent?: React.ReactNode;
}

export default function Header({ title, titleContent, leftContent, rightContent }: HeaderProps) {
    return (
        <header className={styles.header}>
            <div className={styles.leftSlot}>{leftContent}</div>
            <div className={styles.titleArea}>
                {titleContent ?? <span className={styles.title}>{title}</span>}
            </div>
            <div className={styles.rightSlot}>
                {rightContent}
            </div>
        </header>
    );
}
